import { UPDATE_USER, UPDATE_USER_SUCCESSFUL, UPDATE_USER_FAILED } from './actionTypes';

export const updateUser = (user, history) => {
    return {
        type: UPDATE_USER,
        payload: { user, history }
    }
}

export const updateUserSuccessful = (msg) => {
    return {
        type: UPDATE_USER_SUCCESSFUL,
        payload: msg
    }
}

export const updateUserFailed = (msg) => {
    return {
        type: UPDATE_USER_FAILED,
        payload: msg
    }
}
